<template>
	<form-sidebar>
		<header>
			<h2>
				¿Está seguro que desea eliminar el módulo "{{ name }}"?
			</h2>
		</header>
		<section class="modal-filter-footer">
			<modal-sidebar-button
				@cancel-button-clicked="$emit('close-modal')"
				@accept-button-clicked="submitForm"
			>
			</modal-sidebar-button>
		</section>
	</form-sidebar>
</template>

<script>

async function submitForm() {
	try {
		await this.$http.delete(`type-register/${this.id}`);
		this.$emit('close-modal', true);
		this.showNotification('Módulo Contable eliminado correctamente');
	} catch (error) {
		this.showGenericError();
	}
}

export default {
	name: 'modules-remove',
	methods: {
		submitForm,
	},
	props: {
		id: {
			type: Number,
			default: null,
		},
		name: {
			type: String,
			required: true,
		},
	},
};
</script>



// WEBPACK FOOTER //
// src/components/modules/modules-form-remove.vue